import request from '../../utils/request'

const pre="/system/sysTenant";

export const reqListSysTenant = (data) => {
    return request({
        url: pre+'/page',
        method: 'POST',
        data: data
    })
}
export const reqInsertSysTenant = (data) => {
    return request({
        url: pre+'/insert',
        method: 'POST',
        data: data
    })
}
export const reqUpdateSysTenant = (data) => {
    return request({
        url: pre+'/update',
        method: 'POST',
        data: data
    })
}
export const reqDeleteSysTenant = (params) => {
    return request({
        url: pre+'/delete',
        method: 'get',
        params
    })
}
// 同步教学基础数据（异步，返回 taskId）
export const reqSyncTenantData = (data) => {
    return request({
        url: pre+'/syncData',
        method: 'POST',
        data: data
    })
}
// 查询同步任务进度/结果
export const reqSyncTenantResult = (params) => {
    return request({
        url: pre+'/syncResult',
        method: 'get',
        params
    })
}
// 数据一致性校验（对比源租户与目标租户的教学基础数据）
export const reqCheckTenantData = (data) => {
    return request({
        url: pre+'/checkData',
        method: 'POST',
        data: data
    })
}
